import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { startLogin } from '../../../../../actions/auth';
import { AuthLayout } from '../AuthLayout';
import { LoginCard } from './components/LoginCard';
import { LoginHeader } from './components/LoginHeader';
import { LoginForm } from './components/LoginForm';


export const LoginScreen = () => {

    const dispatch = useDispatch();

    const [formValues, setFormValues] = useState({
        email: 'juancarlos@bradev.site',
        password: ''
    });

    const { email, password } = formValues;

    const handleInputChange = ({ target }) => {
        setFormValues({
            ...formValues,
            [target.name]: target.value
        });
    };

    const handleLogin = (e) => {
        e.preventDefault();
        dispatch(startLogin(email, password));
    };

    return (
        <AuthLayout>
            <LoginCard>
                <LoginHeader />
                <LoginForm
                    email={email}
                    password={password}
                    onChange={handleInputChange}
                    onSubmit={handleLogin}
                />
            </LoginCard>
        </AuthLayout>
    )
}
